/**
 * Customer Cool Lead List Component
 */
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import type { CustomerQualifiedProspect } from '@/modules/Customer/types'
import { useCustomerJourneyList } from '@/modules/Customer/hooks/use-customer-journey-list'

const CoolLead = () => {
    const {
        customers,
        pagination,
        stateComponent,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        journeyColumns,
        filterItems,
        handlePageChange,
        handlePageSizeChange,
        handleSortChange,
        getCustomerJourneys,
        hasJourneys,
        t,
    } = useCustomerJourneyList('cool-lead')

    return (
        <Paper className="space-y-2 my-2">
            <FilterBar
                control={control}
                setFilter={setFilter}
                items={filterItems}
            />
            {stateComponent || (
                <DataTableCustomized<CustomerQualifiedProspect>
                    columns={columns}
                    rows={customers}
                    rowKey={(row) => row.customer_id}
                    size="small"
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search_customers'),
                        },
                        settings: {
                            show: true,
                            storageKey: 'customer-cool-lead-list',
                        },
                    }}
                    stickyHeader={{
                        enabled: true,
                        offsetTopSelector: '#main-header',
                    }}
                    expandable={{
                        expandedColumns: journeyColumns,
                        expandedRowData: getCustomerJourneys,
                        expandedRowKey: (journey) =>
                            String(journey.customer_journey_id),
                        rowExpandable: hasJourneys,
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                />
            )}
        </Paper>
    )
}

export default CoolLead
